import ProvincesForm from './ProvincesForm';

export default ProvincesForm;
